import React from 'react';
import '../../styles.css';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { firestore } from '../../Firebase';
import Axios from 'axios'


function VerificationRow(props) {
    return (
        <TableRow>
            <TableCell align="left">{props.userFullName}</TableCell>
            <TableCell className="hide" align="left">{props.username}</TableCell>
            <TableCell className="hide" align="left">{props.email}</TableCell>
            <TableCell align="center">{props.designation}</TableCell>
            <TableCell className="hide" align="center">{props.classCode}</TableCell>
            <TableCell align="center">{props.status}</TableCell>
            <TableCell className="hide" align="center"><button className='verificationButton' id='verify' onClick={() => handleVerify(props)}>Verify</button><button className='verificationButton' id='deny' style={{ color: '#ff000f' }} onClick={() => handleDeny(props)}>Deny</button></TableCell>
        </TableRow>
    );
}

async function handleVerify(props) {
    var id = ""
    var dest = "?dest=" + props.email
    var subject = "&subject=Your decodeLabs account has been verified"
    var message = "&message=Hi, " + props.userFullName + " your account has been verified. Log in whenever!"
    var path = "https://us-central1-dyslexia-d9e5d.cloudfunctions.net/sendMail"
    Axios.get(path + dest + subject + message)
    const matches = await firestore.collection('accounts').where('username', '==', props.username).where('email', '==', props.email).get()
    matches.docs.forEach((doc) => {
        id = doc.id
    })
    firestore.collection('accounts').doc(id).update({
        verified: "true"
    })
    if (props.designation === "teacher") {
        const previous_codes = await firestore.collection("security").doc("genesis").get()
        var previous_codes_sliced = previous_codes.data().classcode
        if (!previous_codes_sliced.includes(props.classCode)) {
            await firestore.collection("security").doc("genesis").update({
                classcode: previous_codes_sliced.concat(props.classCode)
            })
        }
    }
}

async function handleDeny(props) {
    var id = ""
    const matches = await firestore.collection('accounts').where('username', '==', props.username).where('email', '==', props.email).get()
    matches.docs.forEach((doc) => {
        id = doc.id
    })
    firestore.collection('accounts').doc(id).update({
        verified: "false"
    })
    var dest = "?dest=" + props.email
    var subject = "&subject=Your decodeLabs account has been denied"
    var message = "&message=Hi, " + props.userFullName + " your account has been denied. Please contact a teacher for support."
    var path = "https://us-central1-dyslexia-d9e5d.cloudfunctions.net/sendMail"
    Axios.get(path + dest + subject + message)

}

export default VerificationRow;
